<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9XBP0T/tc-custom/9781488007958.jpg?1743867524906" alt="This image is the cover for the book Counterfeit Courtship"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Counterfeit Courtship
      </h1>
      <p class="bookDescription body article font2">
        <i><b>Second Chance Reunion</b></i><i><b> </b></i><br/><br/>Returning home, Confederate hero Colonel Graham Talbot faces his toughest battle yetavoiding the marriage-minded young ladies in town vying for his attentions. With a stepmother and orphaned niece to support, the penniless soldier has no intention of marrying. Neither does the woman he once loved, his next-door neighbor Ellie Anderson. But Ellie has a proposal of her own: a pretend courtship to keep their unwanted admirers at bay. <br/><br/>Ellie's unpredictable childhood left her determined to safeguard her independenceand her plantation. Blaming herself for driving Graham away to war, she devises a plan to help them both. But when it goes awry, Ellie will face a choice: save her beloved propertyor trust in a relationship that's becoming undeniably real.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christina Miller
      </h2>
      
      <p class="authorDescription body article">Christina Miller&#160;left her nursing job to become a writer and editor so she could read for a living. With two theology degrees, she is a pastor’s wife and worship leader. She enjoys exploring museums and hosting Dinner Church in her home. She lives on her family farm with her husband of thirty-three years. Contact Christina through Love Inspired, Facebook.com/christinalinstrotmiller or @clmillerbooks.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71439963